// extracted by mini-css-extract-plugin
export default {"layout":"\"../../../styles/variables/layout.module.css\"","breakpoint-l":"960px","wrapper":"Wrapper_wrapper__pYSLE","background":"Wrapper_background__04H41"};